import { DataBean } from "../DataBean";

export class UpdateStandardCostsImp extends DataBean {



    public async updateProductionOrderStandardCostsImp(idProductionOrder: any, productionOrderDate: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateProductionOrderStandardCostsImp_Number_java.util.Date_Number", [idProductionOrder, productionOrderDate, idEmployee]);
    }

}